<template>
  <div>
    <BinHeader header="ดูรายละเอียดสินค้า" :img_header="header_image" link_back="stock/storage/binstorage"/>
    <Bin_details/>
  </div>
</template>

<script>
import ImageHeader from '@/assets/loupe.png'
import BinHeader from "@/components/admin/stock/storage_bins/header_bin/BinHeader.vue";
import Bin_details from "@/components/admin/stock/storage_bins/Bin_details.vue";
export default {
  name: "BinDetails",
  components: {
    Bin_details,
    BinHeader
  },
  data() {
    return {
      header_image: ImageHeader
    }
  }
}
</script>

<style scoped>

</style>
